<template lang="pug">
.event-swiper
  swiper.swiper-container.mb-5(:options="swiperOption", ref="mySwiper")
    swiper-slide.swiper-slide(
      style="cursor: pointer",
      v-for="(event, index) in eventList",
      :key="index",
      @click.native="toDetail(event.id)"
    )
      a.photo.mb-3(
        v-if="event.photo && type == 'event_headline'",
        :style="{ backgroundImage: 'url(' + event.photo.image + ')' }"
      )
      a.photo.mb-3(
        v-if="type == 'video'",
        :href="event.url",
        target="_blank",
        :style="{ backgroundImage: 'url(' + event.photo + ')' }"
      )
      span.text-black-50.small {{ formatDate(event.created) }}
      a(v-if="type == 'event_headline'")
        h5 {{ event.title }}
      a(v-if="type == 'video'", :href="event.url", target="_blank")
        h5 {{ event.title }}
      span.text-black-50.small.mr-2
        font-awesome-icon.mr-1(:icon="['fas', 'eye']")
        | {{ event.view_count }}
      span.text-black-50.small(v-if="type == 'event_headline'")
        font-awesome-icon.mr-1(:icon="['fas', 'share-alt']") 
        | {{ event.share_count }}
  .swiper-prev(v-if="prevBtnShow", @click="prevClick")
    font-awesome-icon(:icon="['fas', 'chevron-right']", rotation="180") 
  .swiper-next(v-if="nextBtnShow", @click="nextClick")
    font-awesome-icon(:icon="['fas', 'chevron-right']") 
</template>

<script>
import moment from "moment";

export default {
  name: "Events",
  props: {
    eventList: Array,
    type: String,
  },
  data() {
    var self = this;

    //初始slider可見個數
    let views;

    if (document.body.clientWidth < 479) {
      views = 1.5;
    } else if (document.body.clientWidth < 600) {
      views = 2;
    } else {
      views = 4;
    }

    return {
      swiperOption: {
        notNextTick: true,
        initialSlide: 0,
        slidesPerView: views,
        spaceBetween: 0,
        loop: false,
        direction: "horizontal",
        grabCursor: false,
        setWrapperSize: true,
        autoHeight: false,
        mousewheelControl: true,
        observeParents: true,
        debugger: true,
        draggable: true,
        on: {
          resize: function () {
            self.updateSliders();
            this.update();
          },
          slideChangeTransitionEnd: function (data) {
            if (
              data.activeIndex <
              self.eventList.length - self.swiperOption.slidesPerView
            ) {
              self.nextBtnShow = true;
            } else {
              self.nextBtnShow = false;
            }
            if (data.activeIndex > 0) {
              self.prevBtnShow = true;
            } else {
              self.prevBtnShow = false;
            }
          },
        },
      },

      prevBtnShow: false,
      nextBtnShow: true,
    };
  },
  computed: {
    swiper() {
      return this.$refs.mySwiper.$swiper;
    },
  },
  created() {},
  methods: {
    initPrevNext() {
      if (this.eventList.length <= this.swiperOption.slidesPerView) {
        this.prevBtnShow = false;
        this.nextBtnShow = false;
      } else {
        this.prevBtnShow = false;
        this.nextBtnShow = true;
      }
    },
    prevClick() {
      this.swiper.slidePrev();
    },
    nextClick() {
      this.swiper.slideNext();
    },
    updateSliders() {
      if (document.body.clientWidth < 479) {
        this.swiper.params.slidesPerView = 1.5;
      } else if (document.body.clientWidth < 600) {
        this.swiper.params.slidesPerView = 2;
      } else {
        this.swiper.params.slidesPerView = 4;
      }

      this.initPrevNext();
    },
    formatDate(date) {
      return moment(date).format("MMM,DD,YYYY");
    },
    toDetail(id) {
      if (this.type == "event_headline") {
        this.$router.push({
          name: "NewsDetail",
          query: {
            type: "event_headline",
            id: id,
          },
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/style/news/events";
</style>
